import { Link } from "react-router-dom";

import { useMultiStepFormStore } from "@/stores";

export const InsuranceErrorBanner = () => {
  const { goToSpecificFormStep } = useMultiStepFormStore();
  return (
    <div className="col-span-2 w-full rounded-xl border border-error-700 bg-error-50 p-4">
      <p className="text-error-950">
        Insurance information could not be retrieved. Please revise the{" "}
        <Link
          to="#"
          className="underline"
          onClick={() => goToSpecificFormStep(1)}
        >
          General information
        </Link>{" "}
        step.
      </p>
    </div>
  );
};
